import history from "../history";
import { CONFIG } from "../config";
import accountManagement from "../apis/accountManagement";
import { SIGN_IN, CEK_COOKIES, FETCH_ERROR, SIGN_OUT, FETCH_MENU } from "./types";

const errorObj = {type: '', message: ''};
let base64 = require('base-64');
export const signIn = (userInfo) => dispatch => {
    fetch(process.env.REACT_APP_API_AUTH + '/oauth/token', {
        method: "POST",
        headers: {
            'Authorization': 'Basic ' + base64.encode("eduprime:eduprime@123")
        },
        body: userInfo
    })
    .then(res => res.json())
    .then(data => {        
        if(data.error) {
            errorObj.type = 'error';
            errorObj.message = data.error_description;
            dispatch({
                type: FETCH_ERROR,
                payload: errorObj
            })
            //history.push('/login');
        } 
        else {
            localStorage.setItem("user", JSON.stringify(data));
            dispatch({
                type: SIGN_IN,
                payload: data
            })
            errorObj.type = 'success';
            errorObj.message = 'success';
            dispatch({
                type: FETCH_ERROR,
                payload: errorObj
            })
            //history.push('dashboard');
            window.location.assign('/dashboard')
        }
    })
}

export const signOut = () => async (dispatch) => {
  localStorage.removeItem("user");

  errorObj.type = "success";
  errorObj.message = "User Logged Out...!!";
  dispatch({
    type: SIGN_OUT,
    payload: null,
  });
  history.push("/login");
};

export const cekCookies =
  (fromPage = null) =>
  async (dispatch) => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (user === null) {
      errorObj.type = "error";
      errorObj.message = "Not authorized";
      dispatch({
        type: FETCH_ERROR,
        payload: errorObj,
      });
      if (fromPage !== "login") {
        history.push("/login");
      }
    } else {
      dispatch({
        type: CEK_COOKIES,
        payload: user,
      });
      errorObj.type = "success";
      errorObj.message = "success";
      dispatch({
        type: FETCH_ERROR,
        payload: errorObj,
      });

      const responseMenu = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_FETCH_MENU + user.idRole).catch(function (error) {
        errorObj.type = "error";
        errorObj.message = error.message;
        dispatch({
          type: FETCH_ERROR,
          payload: errorObj,
        });
      });
      if (responseMenu) {
        if (responseMenu.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
          dispatch({
            type: FETCH_MENU,
            payload: responseMenu.data,
          });
          if (fromPage === "login") {
            history.push("/dashboard");
          }
        }
      }
    }
  };
